import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fc557c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container overlay" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column justify-content-center overlay-background"
}
const _hoisted_3 = { class: "d-flex flex-column justify-content-between message-container" }
const _hoisted_4 = { class: "my-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-triangle-exclamation" })
], -1))
const _hoisted_6 = { class: "alert-title" }
const _hoisted_7 = { class: "alert-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!
  const _component_AlreadyHaveTrailerAttached = _resolveComponent("AlreadyHaveTrailerAttached")!
  const _component_DriverLoaded = _resolveComponent("DriverLoaded")!
  const _component_LoadingModal = _resolveComponent("LoadingModal")!
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.shouldAlert)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.alertTitle), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.alertMessage), 1)
            ]),
            _createVNode(_component_ReturnOptions, { "in-modal": true })
          ])
        ]))
      : _createCommentVNode("", true),
    (
                _ctx.trailerAssociationsEnabled &&
                _ctx.alreadyAttached &&
                !_ctx.showLoadedTrailerModal
            )
      ? (_openBlock(), _createBlock(_component_AlreadyHaveTrailerAttached, {
          key: 1,
          attachedTrailers: _ctx.currentAttachedTrailers,
          promptStillNearTrailer: true,
          onOnDetach: _ctx.tryRouteToManualAttach,
          onOnSearchForTrailers: _ctx.routeToEnterTrailer
        }, null, 8, ["attachedTrailers", "onOnDetach", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true),
    (
                _ctx.showLoadedTrailerModal &&
                _ctx.currentAttachedTrailerNumber !== null &&
                _ctx.currentAttachedTrailerCompany !== null
            )
      ? (_openBlock(), _createBlock(_component_DriverLoaded, {
          key: 2,
          attachedTrailerNumber: _ctx.currentAttachedTrailers[0].trailerNumber,
          attachedTrailerCompany: _ctx.currentAttachedTrailers[0].company,
          showDeepLinkButton: true,
          onOnSearchForTrailers: _ctx.routeToLanding
        }, null, 8, ["attachedTrailerNumber", "attachedTrailerCompany", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true),
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_LoadingModal, {
          key: 3,
          isFullScreen: "true"
        }))
      : _createCommentVNode("", true),
    (_ctx.hasError)
      ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
          key: 4,
          customBackFunc: _ctx.closeErrorModal,
          message: _ctx.error?.message
        }, null, 8, ["customBackFunc", "message"]))
      : _createCommentVNode("", true)
  ]))
}